




















import { Component, Vue } from "vue-property-decorator";
import { resumeService } from "./resumeService";

@Component
export default class ResumeSummary extends Vue {
    public summary = resumeService.summary;
}
